import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_CELL_CLASS_NAME = 'TableCell';

export const TABLE_CELL_CLASS_SLOTS = ['root'] as const;

export type TableCellClassSlot = (typeof TABLE_CELL_CLASS_SLOTS)[number];

export interface TableCellClasses {
	root: string;
	pinnedLeft: string;
	pinnedRight: string;
	lastPinnedLeft: string;
	firstPinnedRight: string;
	isActionCell: string;
	isDataCell: string;
	isDragHandleCell: string;
	isSelectionCell: string;
	isThumbnailCell: string;
	isUtilityCell: string;
}

export type TableCellClassKey = keyof TableCellClasses;

export const getTableCellUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_CELL_CLASS_NAME, slot);

export const tableCellClasses = generateUtilityClasses<keyof TableCellClasses>(
	TABLE_CELL_CLASS_NAME,
	[
		'root',
		'pinnedLeft',
		'pinnedRight',
		'lastPinnedLeft',
		'firstPinnedRight',
		'isActionCell',
		'isDataCell',
		'isDragHandleCell',
		'isSelectionCell',
		'isThumbnailCell',
		'isUtilityCell',
	],
);
export default tableCellClasses;
